import React from 'react';
import {useNavigate} from 'react-router';
import {CheckOutlined} from '@ant-design/icons';
import { Button} from 'antd';
import cn from 'classnames';

import {INDEX} from '../../config/routes';

import cls from './Order.module.scss'

export const Success = () => {

    const navigate = useNavigate();

    return (
        <div className={cn(['half', cls.page])}>

            <h1><CheckOutlined/> Заказ оформлен</h1>

            <div>
                Спасибо за заказ! Чек и информация о заказе направлена на электронную почту. При возникновение вопросов наши менеджеры свяжутся с вами.
            </div>

            <div>
                <Button type={'primary'} onClick={() => navigate(INDEX)}>Хорошо</Button>
            </div>

        </div>
    )
}